import * as React from "react"
import type { MultiSelectOption } from "@/components/form-generator/types"
import { MultiSelect } from "@/components/ui/custom/multi-select"
import { cn } from "@/lib/utils"

interface MultiSelectWithActionProps
  extends Omit<React.ComponentPropsWithoutRef<typeof MultiSelect>, "options"> {
  options: readonly MultiSelectOption[]
  children?: React.ReactNode
  containerClassName?: string
}

export const MultiSelectWithAction = React.forwardRef<
  HTMLButtonElement,
  MultiSelectWithActionProps
>(({ options, children, containerClassName, ...multiSelectProps }, ref) => {
  // Cast readonly array to mutable array for MultiSelect component
  const mutableOptions = options as MultiSelectOption[]

  return (
    <div className={cn("flex gap-2", containerClassName)}>
      <div className="flex-1">
        <MultiSelect ref={ref} options={mutableOptions} {...multiSelectProps} />
      </div>
      {children && <div className="flex items-start">{children}</div>}
    </div>
  )
})

MultiSelectWithAction.displayName = "MultiSelectWithAction"
